// extracted by mini-css-extract-plugin
module.exports = {"showMoreBase":"styles_showMoreBase__kLZme"};